import React, { useEffect, useState } from "react";
import {
  Card,
  Form,
  Input,
  Button,
  Divider,
  Space,
  Typography,
  message,
} from "antd";
import {
  GoogleOutlined,
  FacebookFilled,
  GithubOutlined,
  EyeInvisibleOutlined,
  EyeTwoTone,
} from "@ant-design/icons";
import { loginApi, registerApi } from "../api/auth";
import { HOSTINGER_PURPLE, HOSTINGER_BG } from "./theme";
import { useNavigate } from "react-router-dom";

const { Title, Text, Link } = Typography;

const Login = ({ authType }) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    const authData = localStorage.getItem("auth");
    if (authData) {
      navigate("/dashboard");
    }
  }, []);
  const onFinish = async (values) => {
    values["email"] = values["username"];
    if (values.password != values.password_confirm && authType === "signup") {
      alert("Passwords do not match");
      message.error("Passwords do not match");

      return;
    }
    console.log("Received values:", values);
    setLoading(true);
    try {
      if (authType === "login") {
        const res = await loginApi(values);
        localStorage.setItem("auth", JSON.stringify(res.data));
        console.log("User:", res.data);
      } else if (authType === "signup") {
        const res = await registerApi(values);
        localStorage.setItem("auth", JSON.stringify(res.data));
        console.log("User:", res.data);
      }

      // Example: token handling

      message.success("Login successful!");
      navigate("/dashboard");
    } catch (err) {
      message.error(err.response?.data?.message || "Invalid email or password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <Card style={styles.card} bordered={false}>
        <Title level={3} style={{ textAlign: "center" }}>
          {authType === "login" ? "Welcome Back!" : "Create an Account"}
        </Title>

        {/* Social Login */}
        <Space style={styles.socialRow}>
          <Button icon={<GoogleOutlined />} />
          <Button
            icon={<FacebookFilled />}
            style={{ background: "#1877F2", color: "#fff" }}
          />
          <Button
            icon={<GithubOutlined />}
            style={{ background: "#24292e", color: "#fff" }}
          />
        </Space>

        <Divider plain>or</Divider>

        {/* Login Form */}
        <Form layout="vertical" onFinish={onFinish} requiredMark={false}>
          <Form.Item
            label="Email address"
            name="username"
            rules={[
              { required: true, message: "Email is required" },
              { type: "email", message: "Enter a valid email" },
            ]}
          >
            <Input placeholder="name@example.com" size="large" />
          </Form.Item>

          <Form.Item
            label="Password"
            name="password"
            rules={[
              { required: true, message: "Password is required" },
              { min: 6, message: "Minimum 6 characters" },
            ]}
          >
            <Input.Password
              size="large"
              placeholder="Enter your password"
              iconRender={(visible) =>
                visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
              }
            />
          </Form.Item>
          {authType === "signup" && (
            <Form.Item
              label="Confirm Password"
              name="password_confirm"
              rules={[
                { required: true, message: "Password is required" },
                { min: 6, message: "Minimum 6 characters" },
              ]}
            >
              <Input.Password
                size="large"
                placeholder="Enter your password"
                iconRender={(visible) =>
                  visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                }
              />
            </Form.Item>
          )}

          <div style={{ textAlign: "right", marginBottom: 16 }}>
            {authType === "login" && <Link>Forgot password?</Link>}
          </div>

          <Button
            type="primary"
            htmlType="submit"
            block
            size="large"
            loading={loading}
            style={{
              background: HOSTINGER_PURPLE,
              borderColor: HOSTINGER_PURPLE,
            }}
          >
            {authType === "login" ? "Log In" : "Sign Up"}
          </Button>
        </Form>

        <div style={styles.footer}>
          {authType === "login" && <Link>Can't access your account?</Link>}
          <br />
          <Text>
            {authType === "login"
              ? "Don't have an account?"
              : "Already have an account?"}{" "}
            <Link
              style={{ color: HOSTINGER_PURPLE }}
              href={authType === "login" ? "/signup" : "/login"}
            >
              {authType === "login" ? "Sign Up" : "Log In"}
            </Link>
          </Text>
        </div>
      </Card>
    </div>
  );
};

export default Login;

const styles = {
  container: {
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: HOSTINGER_BG,
  },
  card: {
    width: 380,
    borderRadius: 12,
    boxShadow: "0 20px 40px rgba(0,0,0,0.08)",
  },
  socialRow: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    gap: 8,
  },
  footer: {
    textAlign: "center",
    marginTop: 24,
  },
};
